"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveLibraryOptions = void 0;
/**
 * @internal
 */
const resolveLibraryOptions = (amplify) => {
    const retryStrategy = amplify.libraryOptions?.API?.REST?.retryStrategy;
    const defaultAuthMode = amplify.libraryOptions?.API?.REST?.defaultAuthMode;
    return { retryStrategy, defaultAuthMode };
};
exports.resolveLibraryOptions = resolveLibraryOptions;
